import joinUrl from 'url-join';
import globalConfig from 'common/js/config';
import { generateUrlWithRegion } from 'common/js/url-utils';
import { getOgAdContext, isWeb } from 'common/js/environment-utils';
import { getScreenSize } from 'common/js/screen-utils';
import { isSupplyMonitoringEventsEnabled } from 'common/js/supply-monitoring-events-enabling';
import { DebugLog } from 'common/js/debug-log';
import ajaxPromise from 'common/js/AjaxPromises';

export const supplyMonitoringTransport = {
  post(url: string, data: Record<string, unknown>): Promise<unknown> {
    if (window.fetch) {
      // bypass valid.es6.sh check for window.fetch
      const windowFetch = window.fetch.bind(window);
      return windowFetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        keepalive: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      });
    }

    return ajaxPromise.postJson(url, data);
  }
};

export function sendSupplyMonitoringEvent(
  event: SUPPLY_MONITORING_EVENT_TYPE,
  adContext: AdContext,
  formatConfig: { isOgurySdk: boolean },
  additionalFields?: OptionalSupplyMonitoringEventFields,
  forceSend?: boolean
): Promise<void> {
  if (
    !forceSend &&
    (window.isOgyPreview || !isSupplyMonitoringEventsEnabled(formatConfig))
  )
    return Promise.resolve();

  const url = joinUrl(
    generateUrlWithRegion(
      globalConfig.MS_ADS_MONITORING_EVENTS_URL,
      adContext.region
    ),
    'supply-monitoring'
  );

  const data = buildSupplyMonitoringEventPayload(
    event,
    adContext,
    additionalFields
  );

  DebugLog.log(`sendSupplyMonitoringEvent: ${event}`, data);

  return supplyMonitoringTransport
    .post(url, data)
    .then(res => DebugLog.log('sendAnalyticsTrack: event sent', res as object));
}

export function buildSupplyMonitoringEventPayload(
  event: SUPPLY_MONITORING_EVENT_TYPE,
  adContext: AdContext,
  additionalFields?: OptionalSupplyMonitoringEventFields
): Record<string, unknown> {
  const screenSize = getScreenSize();
  const ogAdContext = getOgAdContext();

  return {
    environment_type: isWeb() ? 'web' : 'in-app',
    event,
    ad_session_id: ogAdContext.ad_session_id,
    asset_key: ogAdContext.ad_unit_config?.asset_key,
    media_type: ogAdContext.media_type,
    delivery_mode: ogAdContext.delivery_mode,
    bidding_provider: ogAdContext.bidding_provider,
    publisher_name: ogAdContext.publisher_name,
    advert_id: adContext.impressionId,
    ad_unit_id: adContext.adUnitId,
    ad_unit_type: adContext.adUnitType,
    campaign_id: `${adContext.campaignId}`,
    device_type: adContext.deviceType,
    location: adContext.page,
    tag_version:
      window.MRAID_ENV?.sdkVersion || adContext.sdkVersion || 'unknown',
    locale: navigator.language,
    device_screen_width: screenSize.width,
    device_screen_height: screenSize.height,
    sent_at: Math.floor(Date.now() / 1000),
    source: 'formats',
    device_os: adContext.deviceOs,
    format_size_response: adContext.formatSizeResponse,
    supply_source: adContext._appExchange,
    in_article_type:
      adContext.adUnitType === 'in_article'
        ? adContext.inArticleType
        : undefined,
    ...additionalFields
  };
}
